import React, { useState, lazy, Suspense } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { Link,useParams } from "react-router-dom";

// Custom Loader Component
const LoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

const PropertyConfiguration = () => {
  const [activeTab, setActiveTab] = useState("DigitalMenu");

  // Lazy load components
  const MenuList = lazy(() => import("../pos/components/MenuList"));
  const CategoryList = lazy(() => import("../pos/components/CategoryList"));
  const PropertyInfo = lazy(() => import("../pos/components/PropertyInfo"));
  //const TableConfig = lazy(() => import("../pos/components/TableConfig"));
  //const GeneralSettings = lazy(() => import("../pos/components/GeneralSettings"));
  const UserManagement = lazy(() => import("../pos/components/ManageUsers"));
  const POSTax = lazy(() => import("../pos/components/TaxList"));
  //  const WaiterManagement = lazy(() => import("../pos/components/ManageWaiters"));
    const DigitalMenu = lazy(() => import("../pos/components/DigitalMenuList"));

const { source } = useParams();  

  // Conditional class based on source
  const wrapperClass = source && source === 'table-flow' ? 'page-wrapper' : 'page-wrapper-full';
  return (
    <div className={wrapperClass} style={{ marginTop: '-25px' }}>
      <div className="content container-fluid">
       

        <div className="profile-bg-">
          <Tabs
            id="property-config-tabs"
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-4"
          >


            <Tab eventKey="DigitalMenu" title={<><i className="fas fa-users me-2"></i> Digital Menu</>}>
              <div className="card" style={{ marginTop: '-25px' }}>
                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "DigitalMenu" && <DigitalMenu />}
                </Suspense>
              </div>
            </Tab>




            <Tab eventKey="MenuList" title={<><i className="fas fa-bed me-2"></i> Menu Master</>}>
              <div className="card" style={{ marginTop: '-25px' }}>
                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "MenuList" && <MenuList />}
                </Suspense>
              </div>
            </Tab>

            <Tab eventKey="CategoryList" title={<><i className="fas fa-hotel me-2"></i> Menu Categories</>}>
              <div className="card" style={{ marginTop: '-25px' }}>
                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "CategoryList" && <CategoryList />}
                </Suspense>
              </div>
            </Tab>


            <Tab eventKey="POSTax" title={<><i className="fas fa-percent me-2"></i> Taxes</>}>
              <div className="card" style={{ marginTop: '-25px' }}>

                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "POSTax" && <POSTax />}
                </Suspense>
 
              </div>
            </Tab>

            
            <Tab eventKey="propertyInfo" title={<><i className="fas fa-building me-2"></i> Property Information</>}>
              <Suspense fallback={<LoadingSpinner />}>
                {activeTab === "propertyInfo" && <PropertyInfo />}
              </Suspense>
            </Tab>
            

            



  


            <Tab eventKey="manageUsers" title={<><i className="fas fa-users me-2"></i> Manage Users</>}>
              <div className="card" style={{ marginTop: '-25px' }}>
                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "manageUsers" && <UserManagement />}
                </Suspense>
              </div>
            </Tab>

            

          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default PropertyConfiguration;